import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { CommonModule } from "@angular/common";

@Component({
  selector: 'icon-renderer',
  templateUrl: './icon-renderer.component.html',
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class IconRendererComponent implements ICellRendererAngularComp {
  public hasReceipt: boolean = false;
  icon: string = "";

  constructor() { }

  initilize(params: ICellRendererParams) {
    if (params.data) {
      this.hasReceipt = params.data.hasReceipt;
      this.icon = params.colDef.headerComponentParams.icon;
    }
    //delete after testing
    this.hasReceipt = true;
  }

  agInit(params: any): void {
    this.initilize(params);

  }

  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}
